import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { api } from '../../utils/api';
import { brandOr } from '../../utils/brand';

// PUBLIC contract signing page — /contract/:token (no login). The client reviews the agreement and
// e-signs by typing their name. On success the backend kicks off the whole onboarding automation.

export default function ContractSign() {
  const { token = '' } = useParams();
  const [data, setData] = useState<any>(null);
  const [err, setErr] = useState('');
  const [name, setName] = useState('');
  const [signing, setSigning] = useState(false);
  const [done, setDone] = useState(false);

  useEffect(() => { api.contractPublicView(token).then(setData).catch((e: any) => setErr(e.message || 'Contract not found')); }, [token]);

  const sign = async () => {
    if (!name.trim()) { setErr('Please type your full name to sign.'); return; }
    setSigning(true); setErr('');
    try { await api.contractPublicSign(token, name.trim()); setDone(true); }
    catch (e: any) { setErr(e.message); } finally { setSigning(false); }
  };

  const wrap: React.CSSProperties = { maxWidth: 760, margin: '0 auto', padding: '32px 20px', fontFamily: 'Helvetica, Arial, sans-serif', color: '#1d1d1f' };
  const card: React.CSSProperties = { background: '#fff', border: '1px solid #e5e5e5', borderRadius: 14, padding: 28, marginTop: 16 };

  if (err && !data) return <div style={wrap}><div style={{ ...card, color: '#b42318' }}>{err}</div></div>;
  if (!data) return <div style={wrap}><div style={card}>Loading…</div></div>;

  const alreadySigned = data.status === 'signed' || done;

  return (
    <div style={{ minHeight: '100vh', background: '#f5f5f7' }}>
      <div style={wrap}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          <img src="/logo.png" alt={data?.firm || 'Logo'} style={{ width: 34, height: 34, objectFit: 'contain' }} />
          <div style={{ fontSize: 18, fontWeight: 700 }}>{data?.firm || ''}</div>
        </div>

        <div style={card}>
          <div dangerouslySetInnerHTML={{ __html: data.bodyHtml || '' }} />
        </div>

        {alreadySigned ? (
          <div style={{ ...card, background: '#ecfdf5', borderColor: '#a7f3d0', textAlign: 'center' }}>
            <div style={{ fontSize: 32, color: '#15803d', marginBottom: 6 }}>✓</div>
            <div style={{ fontWeight: 700 }}>Signed{data.signerName ? ` by ${data.signerName}` : (name ? ` by ${name}` : '')}</div>
            <div style={{ fontSize: 13, color: '#555', marginTop: 4 }}>Thank you — we'll begin work right away. You'll receive a welcome email shortly.</div>
          </div>
        ) : (
          <div style={card}>
            <div style={{ fontWeight: 700, marginBottom: 10 }}>Sign this agreement</div>
            {err && <div style={{ fontSize: 13, color: '#b42318', background: '#fde8e8', padding: '8px 10px', borderRadius: 8, marginBottom: 10 }}>{err}</div>}
            <label style={{ fontSize: 12, fontWeight: 600, color: '#555', display: 'block', marginBottom: 5 }}>Type your full name to sign</label>
            <input value={name} onChange={e => setName(e.target.value)} placeholder="Your full name"
              style={{ width: '100%', padding: '11px 13px', fontSize: 16, border: '1px solid #ccc', borderRadius: 9, boxSizing: 'border-box', fontFamily: 'cursive' }} />
            <p style={{ fontSize: 12, color: '#777', margin: '10px 0 14px' }}>By clicking “Agree &amp; sign”, you confirm you are authorised to sign on behalf of the client and agree to the terms above.</p>
            <button onClick={sign} disabled={signing} style={{ width: '100%', padding: '13px', fontSize: 15, fontWeight: 700, color: '#fff', background: signing ? '#9aa' : '#0F6E56', border: 'none', borderRadius: 10, cursor: signing ? 'default' : 'pointer' }}>
              {signing ? 'Signing…' : 'Agree & sign'}
            </button>
          </div>
        )}
        <div style={{ textAlign: 'center', fontSize: 11, color: '#999', marginTop: 18 }}>{data?.firm ? `${data.firm} · ` : ''}secured signing link</div>
      </div>
    </div>
  );
}
